import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityFeatures = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      title: 'تشفير البيانات',
      description: 'حماية متقدمة لجميع البيانات الحساسة',
      color: 'var(--color-success)'
    },
    {
      icon: 'Lock',
      title: 'مصادقة آمنة',
      description: 'نظام مصادقة متعدد المستويات',
      color: 'var(--color-primary)'
    },
    {
      icon: 'FileCheck',
      title: 'سجل التدقيق',
      description: 'تتبع كامل لجميع العمليات',
      color: 'var(--color-accent)'
    },
    {
      icon: 'Clock',
      title: 'إدارة الجلسات',
      description: 'انتهاء تلقائي للجلسات غير النشطة',
      color: 'var(--color-warning)'
    }
  ];

  return (
    <div className="w-full space-y-4 md:space-y-6">
      <div className="text-center">
        <h3 className="text-lg md:text-xl font-heading font-semibold text-white mb-2">
          ميزات الأمان المتقدمة
        </h3>
        <p className="text-sm md:text-base text-white/70 font-caption">
          نظام حماية شامل لضمان أمان بياناتك
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {securityFeatures?.map((feature, index) => (
          <div
            key={index}
            className="flex items-start gap-4 p-4 bg-card border border-border rounded-lg hover:shadow-warm-sm transition-all duration-250"
          >
            <div
              className="flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center"
              style={{ backgroundColor: `${feature?.color}15` }}
            >
              <Icon name={feature?.icon} size={24} color={feature?.color} />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm md:text-base font-heading font-semibold text-white mb-1">
                {feature?.title}
              </h4>
              <p className="text-xs md:text-sm text-white/70 font-caption line-clamp-2">
                {feature?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="flex items-center gap-3 p-4 bg-success/10 border border-success/20 rounded-lg">
        <Icon name="CheckCircle2" size={20} color="var(--color-success)" className="flex-shrink-0" />
        <p className="text-sm text-success font-medium">
          جميع الاتصالات محمية بتشفير SSL/TLS
        </p>
      </div>
    </div>
  );
};

export default SecurityFeatures;